import { useVideosList } from 'lib/hooks/queries/video/useVideosList';

import AgTablePage from 'components/shared/AgTablePage/AgTablePage';

import Modal from './components/Modal';
import { DEFAULT_COLUMNS, DEFAULT_FILTERS } from './lib/helpers';

const Videos = () => {
  return (
    <AgTablePage
      ModalComponent={Modal}
      useData={useVideosList}
      name="videos"
      onSelectRow={() => {}}
      defaultColumns={DEFAULT_COLUMNS}
      defaultFilters={DEFAULT_FILTERS}
      queryParams={{ withCount: true }}
    />
  );
};

export default Videos;
